import { isJSON } from './helpers/utilityHelpers';

type LocalStorageKeys =
  | 'access_token'
  | 'refresh_token'
  | 'user_email'
  | 'theme'
  | 'nav_visible_items'
  | 'language'
  /** Written by the library's DataTable (order, visibility and widths, one entry per table). */
  | 'datatable-columns'
  /** Whether the portfolio's time-source breakdown is open. It starts closed. */
  | 'ops-fontes-aberto'
  /** Whether the queue's "does not fit the deadline" warning is open. It starts closed. */
  | 'fila-nao-cabe-aberto'
  /** Whether the simulator's calculation memo is open. It starts closed. */
  | 'simulador-memoria-aberta'
  /** The cell this tablet points: it sits at one workstation and answers for one cell. */
  | 'apontamento-ultima-celula'
  /** The last OP pointed in each cell, so the next hour opens on it. */
  | 'apontamento-ultima-op';

class LocalStorageManager {
  private static instance: LocalStorageManager;

  static getInstance(): LocalStorageManager {
    if (!LocalStorageManager.instance) {
      LocalStorageManager.instance = new LocalStorageManager();
    }
    return LocalStorageManager.instance;
  }

  setItem<T>(key: LocalStorageKeys, content: T) {
    if (typeof window === 'undefined') return;
    try {
      localStorage.setItem(key, JSON.stringify(content));
    } catch (error) {
      logger.error(`[LocalStorage] Failed to set "${key}"`, error);
      throw error;
    }
  }

  getItem<T>(key: LocalStorageKeys): T | null {
    if (typeof window === 'undefined') return null;
    const storedValue = localStorage.getItem(key);
    if (!storedValue) return null;

    try {
      return (isJSON(storedValue) ? JSON.parse(storedValue) : storedValue) as T;
    } catch (error) {
      logger.error(`[LocalStorage] Failed to get "${key}"`, error);
      return null;
    }
  }

  removeItem(key: LocalStorageKeys) {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(key);
  }

  clear() {
    if (typeof window === 'undefined') return;
    localStorage.clear();
  }
}

export const localStorageManager = LocalStorageManager.getInstance();
